<template>
    <div>
          <v-flex :key="key" grow my-1>
        <v-card class="rounded-card" >
          <v-card-text>
            <h2 class="dark-grey--text">Transactions</h2>
            <div >
              <v-data-table
                :headers="transactionHeaders"
                :items="transactions"
                :rows-per-page-items="[5]"
              >
                <template v-slot:items="props">
                  <td>
                           <v-btn flat color="primary" @click="viewInvoice(props.item)">View</v-btn>
                         </td>
                  <td > {{props.item.DocumentNumber}}</td>
                  <td > {{formatDate(props.item.Date)}}</td>
                  <td > {{props.item.Total | currency}}</td>
                  <td >
                    <v-chip small v-if="props.item.AmountDue<=0" color="light-green" class="white--text">Paid</v-chip>
                    <v-chip small v-else-if="props.item.AmountDue>0&&props.item.AmountDue<props.item.Total" color="orange" class="white--text">Partially Paid</v-chip>
                    <v-chip small v-else-if="props.item.AmountDue == props.item.Total" color="red" class="white--text">Unpaid</v-chip>
                  </td>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
       <v-dialog v-model="invoiceModal" max-width="1000px" min-width="300px">
       <SageInvoiceModal  :invoice="invoiceItem" :taxtypes="taxtypes"
       :type="'read'"
       @closeModal="invoiceItem={}, invoiceModal=false"
       ></SageInvoiceModal>
    </v-dialog>
    </div>
</template>
<script>
import Api from '../services/Api'
import dateformat from "dateformat";
import SageInvoiceModal from '../components/SageInvoiceModal'
export default {
    props: ['transactions', 'taxtypes'],
    components: {
      SageInvoiceModal
    },
    data(){
        return {
          invoiceItem: {},
          invoiceModal :false,
transactionHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Document No.",
          align: "center",
          value: "DocumentNumber"
        },
        {
          text: "Date",
          align: "center",
          value: "Date"
        },
        {
          text: "Amount",
          align: "center",
          value: "Total"
        }
        ,
        {
          text: "Status",
          align: "center",
          value: "AmountDue"
        }
      ],
        }
    },
    methods: {
        formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    async viewInvoice(item){
        await Api().get('/sageOne/invoice/'+item.AllocatedToDocumentId).then(res=>{
        this.invoiceItem = res.data
        this.invoiceModal = true
      })
      
    },
    }
}
</script>